/**
 * @generated SignedSource<<5c3423a72cc2d82871e7a57d9a292aae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCharge_charge$data = {
  readonly company: {
    readonly projectType: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"PaymentCompanyLogo_company" | "PaymentCompanySupport_company">;
  } | null | undefined;
  readonly customer: {
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly customerRegister: boolean | null | undefined;
  readonly id: string;
  readonly isFromTestAccount: boolean | null | undefined;
  readonly isRemoved: boolean | null | undefined;
  readonly paymentMethodSelected: string | null | undefined;
  readonly status: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveWaitingCustomerFillData_charge" | "PaymentActiveWaitingPaymentMethodRoot_charge" | "PaymentActive_charge" | "PaymentCompleted_charge" | "PaymentDeleted_charge" | "PaymentDispute_charge" | "PaymentExpired_charge" | "PaymentMethodBoletoSelected_charge" | "PaymentMethodCreditCardSelected_charge" | "PaymentMethodPixSelected_charge" | "PaymentMethodSelectedPending_charge" | "PaymentShopify_charge" | "PaymentTestAccountBanner_charge">;
  readonly " $fragmentType": "PaymentCharge_charge";
};
export type PaymentCharge_charge$key = {
  readonly " $data"?: PaymentCharge_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCharge_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCharge_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRemoved",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerRegister",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "customer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFromTestAccount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentMethodSelected",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectType",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCompanySupport_company"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCompanyLogo_company"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActive_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveWaitingPaymentMethodRoot_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentDeleted_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCompleted_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentExpired_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveWaitingCustomerFillData_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentTestAccountBanner_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodCreditCardSelected_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodBoletoSelected_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentDispute_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodSelectedPending_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodPixSelected_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentShopify_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "fe809f9f4fa3da7cc50e41831b4e31c8";

export default node;
